export default "__VITE_ASSET__A75GCFHy__"